<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">

  <div class="animate-fade-in flex flex-col lg:flex-row lg:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">
        ข่าว / ประชาสัมพันธ์
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        บอร์ดประกาศสำหรับพนักงาน — เห็นทั้งข่าวภายในและสาธารณะ
      </p>
    </div>
    <div class="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center self-start flex-wrap">
      <div class="inline-flex p-1 rounded-2xl bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700 shadow-sm">
        <button type="button" (click)="setViewMode('board')"
          class="px-4 h-9 rounded-xl text-xs font-bold transition-all cursor-pointer border-none"
          [ngClass]="viewMode() === 'board' ? 'bg-amber-400 text-slate-900 shadow-sm' : 'bg-transparent text-slate-500 hover:text-amber-600'">
          บอร์ดข่าว
        </button>
        <button *ngIf="canCreate || canUpdate" type="button" (click)="setViewMode('manage')"
          class="px-4 h-9 rounded-xl text-xs font-bold transition-all cursor-pointer border-none"
          [ngClass]="viewMode() === 'manage' ? 'bg-amber-400 text-slate-900 shadow-sm' : 'bg-transparent text-slate-500 hover:text-amber-600'">
          จัดการ
        </button>
      </div>
      <span class="text-xs text-slate-400 whitespace-nowrap self-center">
        ดึงข้อมูลล่าสุด:
        <strong class="text-slate-600 dark:text-slate-300">
          {{ lastFetchedAt() ? (lastFetchedAt() | date:'dd/MM/yyyy HH:mm:ss') : 'ยังไม่ได้ดึงข้อมูล' }}
        </strong>
      </span>
      <button type="button" (click)="onRefresh()" title="ดึงข้อมูล"
        class="px-4 py-3 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center gap-2 cursor-pointer font-bold">
        <span class="material-icons">refresh</span>
        <span>ดึงข้อมูล</span>
      </button>
      <button *ngIf="canCreate" type="button" (click)="openCreate()"
        class="px-6 py-3 h-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-500/20 flex items-center justify-center gap-2 cursor-pointer transition-all">
        <span class="material-icons text-xl">add_circle</span>
        สร้างข่าว
      </button>
    </div>
  </div>

  <div class="bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 overflow-hidden relative">
    <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

    <!-- Filters -->
    <div class="p-6 border-b border-slate-100 dark:border-slate-800 space-y-4">
      <div class="flex items-center gap-2 mb-1">
        <span class="material-icons text-amber-500 text-[20px]">newspaper</span>
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">
          {{ viewMode() === 'board' ? 'บอร์ดประกาศ' : 'จัดการข่าว' }}
        </h3>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-3">
        <div class="relative xl:col-span-2">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
          <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()"
            placeholder="ค้นหาหัวข้อ..."
            class="w-full pl-10 pr-4 h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30 placeholder:text-slate-400" />
        </div>

        <div class="relative">
          <select [(ngModel)]="filterVisibility" (change)="onSearch()"
            class="w-full appearance-none px-4 pr-10 h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option value="">ทั้งหมด (ภายใน + สาธารณะ)</option>
            <option value="internal">ภายใน</option>
            <option value="public">สาธารณะ (ลูกค้า)</option>
          </select>
          <span class="absolute right-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 pointer-events-none">expand_more</span>
        </div>

        <div class="relative" *ngIf="viewMode() === 'manage'">
          <select [(ngModel)]="filterStatus" (change)="onSearch()"
            class="w-full appearance-none px-4 pr-10 h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option value="">Status ทั้งหมด</option>
            <option value="draft">ร่าง</option>
            <option value="published">เผยแพร่</option>
            <option value="archived">เก็บถาวร</option>
          </select>
          <span class="absolute right-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 pointer-events-none">expand_more</span>
        </div>

        <div class="relative">
          <select [(ngModel)]="filterCategoryId" (change)="onSearch()"
            class="w-full appearance-none px-4 pr-10 h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option [ngValue]="null">ประเภททั้งหมด</option>
            <option *ngFor="let c of categories()" [ngValue]="c.id">{{ c.name }}</option>
          </select>
          <span class="absolute right-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 pointer-events-none">expand_more</span>
        </div>
      </div>

      <label class="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700 cursor-pointer select-none">
        <input type="checkbox" [(ngModel)]="filterByCurrentSite" (change)="onSearch()"
          class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400 cursor-pointer" />
        <span class="text-xs font-bold text-slate-600 dark:text-slate-300">
          กรองตามลานปัจจุบัน
          <span class="text-slate-400 font-medium">(ไม่ติ๊ก = รวม Global + ทุก site)</span>
        </span>
      </label>
    </div>

    <!-- Board cards -->
    <div *ngIf="viewMode() === 'board'" class="p-6 min-h-[320px]">
      <div *ngIf="!isLoading() && items().length === 0"
        class="py-20 text-center text-slate-400">
        <span class="material-icons text-5xl opacity-40 block mb-3">campaign</span>
        <p class="font-bold text-slate-500">ยังไม่มีประกาศในช่วงนี้</p>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
        <button type="button" *ngFor="let item of items()" (click)="openDetail(item.id)"
          class="group text-left rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800/80 shadow-sm hover:shadow-lg hover:border-amber-200/80 dark:hover:border-amber-700/50 transition-all cursor-pointer p-0">
          <div class="relative h-40 bg-slate-100 dark:bg-slate-900 overflow-hidden">
            <img *ngIf="item.coverImageUrl" [src]="item.coverImageUrl" [alt]="item.title"
              class="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300" />
            <div *ngIf="!item.coverImageUrl"
              class="w-full h-full flex items-center justify-center bg-amber-50 dark:bg-amber-950/30">
              <span class="material-icons text-amber-400 text-4xl opacity-70">newspaper</span>
            </div>
            <span *ngIf="item.pin"
              class="absolute top-3 left-3 px-2.5 py-1 rounded-lg bg-amber-400 text-[10px] font-bold text-slate-900 shadow-sm">
              ปักหมุด
            </span>
            <span class="absolute top-3 right-3 px-2.5 py-1 rounded-lg text-[10px] font-bold border"
              [ngClass]="visibilityClass(item.visibility)">
              {{ visibilityLabel(item.visibility) }}
            </span>
          </div>
          <div class="p-4 space-y-2">
            <div class="flex items-center gap-2 flex-wrap">
              <span *ngIf="item.categoryName"
                class="px-2 py-0.5 rounded-lg bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 text-[10px] font-bold">
                {{ item.categoryName }}
              </span>
              <span *ngIf="!item.siteId"
                class="px-2 py-0.5 rounded-lg bg-sky-50 dark:bg-sky-950/40 text-sky-700 dark:text-sky-300 text-[10px] font-bold">Global</span>
              <span *ngIf="item.siteName"
                class="px-2 py-0.5 rounded-lg bg-emerald-50 dark:bg-emerald-950/40 text-emerald-700 dark:text-emerald-300 text-[10px] font-bold">
                {{ item.siteName }}
              </span>
              <span *ngIf="item.siteId && item.visibility !== 'internal'"
                class="px-2 py-0.5 rounded-lg text-[10px] font-bold"
                [ngClass]="siteNewsScopeClass(item)">
                {{ siteNewsScopeLabel(item) }}
              </span>
            </div>
            <h4 class="text-sm font-extrabold text-slate-800 dark:text-slate-100 line-clamp-2 leading-snug">
              {{ item.title }}
            </h4>
            <p *ngIf="item.summary" class="text-xs text-slate-500 dark:text-slate-400 line-clamp-2">
              {{ item.summary }}
            </p>
            <div class="pt-1 flex items-center gap-1.5 text-[11px] text-slate-400 font-medium">
              <span class="material-icons text-[14px]">event</span>
              <span>เผยแพร่ {{ publishLabel(item) }}</span>
            </div>
          </div>
        </button>
      </div>
    </div>

    <!-- Manage table -->
    <div *ngIf="viewMode() === 'manage'" class="overflow-x-auto min-h-[280px] custom-scrollbar">
      <table class="w-full text-left text-sm">
        <thead class="bg-slate-50/80 dark:bg-slate-800/50 text-[11px] uppercase tracking-wider text-slate-400">
          <tr>
            <th class="px-5 py-4 font-bold w-14 text-center">Pin</th>
            <th class="px-5 py-4 font-bold">หัวข้อ</th>
            <th class="px-5 py-4 font-bold">ประเภท</th>
            <th class="px-5 py-4 font-bold">Visibility</th>
            <th class="px-5 py-4 font-bold">Status</th>
            <th class="px-5 py-4 font-bold">Site</th>
            <th class="px-5 py-4 font-bold">เผยแพร่</th>
            <th class="px-5 py-4 font-bold text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items()"
            class="border-t border-slate-100 dark:border-slate-800 hover:bg-amber-50/40 dark:hover:bg-amber-900/10 transition-colors">
            <td class="px-5 py-4 text-center">
              <span *ngIf="item.pin" class="material-icons text-amber-500 text-[18px]" title="ปักหมุด">push_pin</span>
            </td>
            <td class="px-5 py-4 max-w-[280px]">
              <button type="button" (click)="openDetail(item.id)"
                class="font-bold text-slate-800 dark:text-slate-100 truncate text-left hover:text-amber-600 bg-transparent border-none cursor-pointer p-0"
                [title]="item.title">{{ item.title }}</button>
              <div class="text-xs text-slate-400 mt-0.5 line-clamp-1">{{ item.summary || '—' }}</div>
            </td>
            <td class="px-5 py-4 text-xs font-semibold text-slate-600 dark:text-slate-300">
              {{ item.categoryName || item.categoryCode || '—' }}
            </td>
            <td class="px-5 py-4">
              <span class="px-2.5 py-1 rounded-lg text-[11px] font-bold"
                [ngClass]="visibilityClass(item.visibility)">
                {{ visibilityLabel(item.visibility) }}
              </span>
            </td>
            <td class="px-5 py-4">
              <span class="px-2.5 py-1 rounded-lg text-[11px] font-bold" [ngClass]="statusClass(item.status)">
                {{ statusLabel(item.status) }}
              </span>
            </td>
            <td class="px-5 py-4 text-xs font-medium text-slate-600 dark:text-slate-300">
              <div>{{ item.siteName || (item.siteId ? ('Site #' + item.siteId) : 'ทุก site') }}</div>
              <span *ngIf="item.siteId && item.visibility !== 'internal'"
                class="inline-block mt-1 px-2 py-0.5 rounded-lg text-[10px] font-bold"
                [ngClass]="siteNewsScopeClass(item)">
                {{ siteNewsScopeLabel(item) }}
              </span>
            </td>
            <td class="px-5 py-4 text-xs tabular-nums text-slate-500">{{ publishLabel(item) }}</td>
            <td class="px-5 py-4 text-center">
              <button *ngIf="canUpdate" type="button" (click)="openEdit(item)" title="แก้ไข"
                class="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-slate-50 dark:bg-slate-800 text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-900/20 border border-slate-100 dark:border-slate-700 transition-colors cursor-pointer">
                <span class="material-icons text-[18px]">edit</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && items().length === 0">
            <td colspan="8" class="px-6 py-16 text-center text-slate-400">
              <span class="material-icons text-4xl opacity-40 block mb-2">inbox</span>
              ไม่พบข่าว
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="totalCount() > 0"
      class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalCount() | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
          <option *ngFor="let size of currentPageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="onPageChange(page() - 1)" [disabled]="page() <= 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button type="button" *ngFor="let p of pagesArray" (click)="onPageChange(p)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer border-none"
          [ngClass]="p === page() ? 'bg-amber-400 text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 bg-transparent'">
          {{ p }}
        </button>
        <button type="button" (click)="onPageChange(page() + 1)" [disabled]="page() >= totalPages"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Detail modal -->
  <div *ngIf="isDetailOpen()"
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
    (click)="closeDetail()">
    <div class="relative w-full max-w-3xl max-h-[90vh] overflow-hidden bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-700 flex flex-col"
      (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800">
        <h2 class="text-lg font-extrabold text-slate-800 dark:text-slate-100">รายละเอียดประกาศ</h2>
        <div class="flex items-center gap-2">
          <button *ngIf="canUpdate && detail()" type="button" (click)="openEdit(detail()!); closeDetail()"
            class="px-3 h-9 rounded-xl text-xs font-bold bg-amber-400 text-slate-900 border-none cursor-pointer">
            แก้ไข
          </button>
          <button type="button" (click)="closeDetail()"
            class="w-9 h-9 rounded-xl bg-slate-100 dark:bg-slate-800 border-none cursor-pointer flex items-center justify-center text-slate-500 hover:text-rose-500">
            <span class="material-icons text-[20px]">close</span>
          </button>
        </div>
      </div>

      <div class="overflow-y-auto custom-scrollbar flex-1 relative min-h-[200px]">
        <app-pss-loading *ngIf="isDetailLoading()"></app-pss-loading>

        <ng-container *ngIf="detail() as d">
          <button *ngIf="d.coverImageUrl" type="button" (click)="openZoom(d.coverImageUrl)"
            class="w-full h-52 bg-slate-100 overflow-hidden border-0 p-0 cursor-pointer">
            <img [src]="d.coverImageUrl" [alt]="d.title" class="w-full h-full object-cover" />
          </button>

          <div class="px-6 py-5 space-y-4">
            <div class="flex items-center gap-2 flex-wrap">
              <span *ngIf="d.pin"
                class="px-2.5 py-1 rounded-lg bg-amber-100 text-amber-700 text-[10px] font-bold">ปักหมุด</span>
              <span class="px-2.5 py-1 rounded-lg text-[10px] font-bold border"
                [ngClass]="visibilityClass(d.visibility)">{{ visibilityLabel(d.visibility) }}</span>
              <span *ngIf="d.categoryName"
                class="px-2.5 py-1 rounded-lg bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 text-[10px] font-bold">
                {{ d.categoryName }}
              </span>
              <span *ngIf="!d.siteId"
                class="px-2.5 py-1 rounded-lg bg-sky-50 text-sky-700 text-[10px] font-bold">Global</span>
              <span *ngIf="d.siteName"
                class="px-2.5 py-1 rounded-lg bg-emerald-50 text-emerald-700 text-[10px] font-bold">{{ d.siteName }}</span>
              <span *ngIf="d.siteId && d.visibility !== 'internal'"
                class="px-2.5 py-1 rounded-lg text-[10px] font-bold"
                [ngClass]="siteNewsScopeClass(d)">{{ siteNewsScopeLabel(d) }}</span>
            </div>

            <h3 class="text-xl font-extrabold text-slate-800 dark:text-slate-100 leading-snug">{{ d.title }}</h3>

            <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700 px-4 py-3 text-xs text-slate-500 space-y-1.5">
              <div class="flex gap-2">
                <span class="font-bold text-slate-400 w-28 shrink-0">วันเผยแพร่</span>
                <span class="tabular-nums font-semibold text-slate-700 dark:text-slate-200">{{ publishLabel(d) }}</span>
              </div>
              <div class="flex gap-2" *ngIf="d.publishFrom">
                <span class="font-bold text-slate-400 w-28 shrink-0">เริ่มแสดง</span>
                <span class="tabular-nums">{{ formatDate(d.publishFrom) }}</span>
              </div>
              <div class="flex gap-2" *ngIf="d.publishTo">
                <span class="font-bold text-slate-400 w-28 shrink-0">สิ้นสุด</span>
                <span class="tabular-nums">{{ formatDate(d.publishTo) }}</span>
              </div>
            </div>

            <p *ngIf="d.summary" class="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">{{ d.summary }}</p>
            <div *ngIf="d.body" class="text-sm text-slate-700 dark:text-slate-200 whitespace-pre-wrap leading-relaxed">
              {{ d.body }}
            </div>

            <div *ngIf="d.images?.length" class="pt-2">
              <h4 class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3">รูปในเนื้อหา</h4>
              <div class="grid grid-cols-2 sm:grid-cols-3 gap-3">
                <button type="button" *ngFor="let img of d.images" (click)="openZoom(img.fullPath)"
                  class="relative aspect-[4/3] rounded-xl overflow-hidden border border-slate-100 dark:border-slate-700 bg-slate-50 p-0 cursor-pointer">
                  <img [src]="img.fullPath" [alt]="img.caption || ''" class="w-full h-full object-cover" />
                </button>
              </div>
            </div>

            <button *ngIf="d.linkUrl" type="button" (click)="openLink(d.linkUrl)"
              class="w-full mt-2 py-3 rounded-2xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-sm font-bold border-none cursor-pointer">
              {{ d.linkLabel || 'เปิดลิงก์' }}
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Zoom -->
  <div *ngIf="zoomUrl()" class="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-4"
    (click)="closeZoom()">
    <button type="button" (click)="closeZoom()"
      class="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/15 flex items-center justify-center border-none cursor-pointer text-white">
      <span class="material-icons">close</span>
    </button>
    <img [src]="zoomUrl()!" alt="zoom" class="max-w-full max-h-[85vh] object-contain rounded-xl"
      (click)="$event.stopPropagation()" />
  </div>

  <app-modal-news
    *ngIf="isModalOpen()"
    [editId]="editId()"
    (close)="closeModal()"
    (saveSuccess)="onSaved()">
  </app-modal-news>
</div>
